import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

const Ctx = createContext<{ path: string; navigate: (to: string, replace?: boolean) => void }>({ path: "/", navigate: () => {} });

export function RouterProvider({ children }: { children: ReactNode }) {
  const [path, setPath] = useState(location.pathname);
  // `path` excludes the query string; screens read query parameters from location.search.
  useEffect(() => { const on = () => setPath(location.pathname); addEventListener("popstate", on); return () => removeEventListener("popstate", on); }, []);
  const navigate = (to: string, replace = false) => {
    if (replace) history.replaceState(null, "", to); else history.pushState(null, "", to);
    setPath(to.split("?")[0]!); scrollTo(0, 0);
  };
  return <Ctx.Provider value={{ path, navigate }}>{children}</Ctx.Provider>;
}
export const useRouter = () => useContext(Ctx);

export function Link({ to, children, className }: { to: string; children: ReactNode; className?: string }) {
  const { navigate } = useRouter();
  return <a href={to} className={className} onClick={(e) => { if (e.metaKey || e.ctrlKey) return; e.preventDefault(); navigate(to); }}>{children}</a>;
}
